/**
 * The sizes of the current finish (PosterBaseOptions) : the customer's poster drawn in each at one
 * scale on one baseline (PosterOptionsView sets the scale), its name, size and price, "Le + choisi"
 * on the format the catalogue says (creation_format.best).
 */
fx.ns("shared.components", class PosterSizeOptions extends shared.components.PosterBaseOptions {

    get kind() { return "size"; }

    get title()
    {
        return fx.text("Pour la taille, on part sur quoi ?");
    }

    get subtitle()
    {
        // none in the sheet : the cards say it themselves, and the room goes to them
        return this.mobile ? "" : fx.text("Les aperçus sont à la même échelle : comparez d'un coup d'œil.");
    }

    // the formats of the current finish, in the poster's orientation, cheapest first
    get _options()
    {
        let creation = this.creation;
        return creation.creationOptions
            .filter((option) => option.option.id == creation.optionid && creation.inOrientation(option))
            .sort((a, b) => a.price_base - b.price_base);
    }

    cards()
    {
        let Base = shared.components.PosterBaseOptions;
        let creation = this.creation;

        return this._options.map((option) => {
            let format = option.format;
            let size = this.dimensions(format);
            let selected = creation.formatid == format.id;
            let code = String(format.code || "").toUpperCase();
            let name = this.mobile ? code : fx.text("Poster") + " " + code;

            return { id : format.id, html :
                '<button type="button" class="poCard" data-action="choose" data-id="' + format.id + '" aria-pressed="' + selected + '">' +
                    '<span class="poStage">' +
                        '<span class="poPoster" data-w="' + size.width + '" data-h="' + size.height + '"><img class="poArt" alt=""></span>' +
                    '</span>' +
                    '<span class="poInfo">' +
                        '<span class="poRow"><span class="poName">' + Base.escape(name) + '</span><span class="poPrice">' + this.price(option) + '</span></span>' +
                        '<span class="poDims">' + this.dimensionsLabel(size) + '</span>' +
                    '</span>' +
                    (Number(format.best) ? '<span class="poBadge">' + fx.text("Le + choisi") + '</span>' : '') +
                    Base.check() +
                '</button>' };
        });
    }

    apply(id)
    {
        this.creation.updateFormat(Number(id));
    }
});
